export const SEATS_VERSIONS_FEATURE_FLAG = 'SEATS_VERSIONS_FEATURE_FLAG';
export const HUBSPOT_CREDITS_FLAG = 'HUBSPOT_CREDITS_FLAG';